import React from "react";
import { NavLink } from "react-router-dom";
import hospitalityBanner from "../../assets/images/hospitality/hospitalityBanner.png";

const Banner = () => {
  return (
    <section
      className="tw-relative tw-overflow-hidden tw-bg-white tw-pt-16 tw-pb-20 lg:tw-pt-24 lg:tw-pb-28"
      id="hospitality-banner"
    >
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-relative tw-z-10 tw-text-center">
        
        {/* Badge */}
        <div className="tw-inline-flex tw-items-center tw-gap-2 tw-mb-6 tw-px-3.5 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-[#5D44FF]/20 tw-bg-[#5D44FF]/5 tw-text-[#5D44FF] tw-text-xs tw-font-semibold tw-tracking-wide">
          🏨 Hospitality Growth
        </div>

        {/* Heading */}
        <h1 className="tw-text-3xl sm:tw-text-4xl lg:tw-text-5xl tw-font-extrabold tw-tracking-tight tw-leading-[1.2] tw-mb-6 tw-text-slate-900 tw-max-w-4xl tw-mx-auto">
          Drive More Bookings and Build Stronger <br />
          <span className="tw-text-[#5D44FF]">Guest Relationships</span>
        </h1>

        {/* Description */}
        <p className="tw-text-base sm:tw-text-lg tw-text-slate-600 tw-leading-relaxed tw-mb-8 tw-max-w-3xl tw-mx-auto">
          BeyondLeadz: Targeted Marketing and Lead Generation for the Hospitality Industry. Reach the right audience, convert more leads, and enhance guest loyalty.
        </p>

        {/* CTA Buttons */}
        <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 tw-justify-center tw-mb-12">
          <NavLink
            to="/signup"
            className="hero-btn-shine tw-inline-flex tw-items-center tw-justify-center tw-px-8 tw-py-3.5 tw-bg-[#5D44FF] hover:tw-bg-indigo-600 tw-text-white tw-font-bold tw-text-sm tw-rounded-xl tw-shadow-lg tw-shadow-indigo-500/20 tw-transition-all hover:tw-scale-[1.03]"
          >
            Subscribe Now
          </NavLink>
          <NavLink
            to="/contact-us"
            className="tw-inline-flex tw-items-center tw-justify-center tw-px-8 tw-py-3.5 tw-bg-transparent tw-border-2 tw-border-solid tw-border-[#5D44FF] hover:tw-bg-indigo-50 tw-text-[#5D44FF] tw-font-bold tw-text-sm tw-rounded-xl tw-transition-all hover:tw-scale-[1.03]"
          >
            Contact us
          </NavLink>
        </div>

        {/* Bottom Banner Image Mockup */}
        <div className="tw-relative tw-max-w-4xl tw-mx-auto tw-z-10">
          <div className="hero-img-glow tw-opacity-35 tw-blur-2xl" />
          <img
            src={hospitalityBanner}
            alt="Hospitality Growth Solutions"
            className="tw-w-full tw-h-auto tw-object-contain img-shadow-indigo tw-rounded-3xl"
            loading="lazy"
          />
        </div>

      </div>

      {/* Bottom wave divider */}
      <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-overflow-hidden tw-leading-none">
        <svg className="tw-relative tw-block tw-w-full tw-h-12" viewBox="0 0 1440 320" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,320L48,293.3C96,267,192,213,288,192C384,171,480,181,576,202.7C672,224,768,256,864,224C960,192,1056,96,1152,85.3C1248,75,1344,149,1392,186.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="#F5F4FF" fillOpacity="0.5" />
        </svg>
      </div>
    </section>
  );
};

export default Banner;
